import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShellIcon from './ShellIcon';

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  return <form className="speem-search" role="search" onSubmit={event => {
    event.preventDefault(); if (query.trim()) navigate(`/search?q=${encodeURIComponent(query.trim())}`);
  }}>
    <button type="submit" aria-label="Search Speem"><ShellIcon name="search" size={16} /></button>
    <input type="search" placeholder="Search Speem" aria-label="Search Speem" value={query} onChange={event => setQuery(event.target.value)} />
  </form>;
}
